import { docodeHexResponse } from '../_common/common.utils';
import CompanyActionTypes from './company.type';

const INITIAL_STATE = {
	addCompanyDetailsResp: null,

	getCompanyListResp: null,
	getCompanyListArr: [],

	fetchCompanyDetailsResp: null,
	fetchCompanyDetailsArr: [],

	updateCompanyDetailsResp: null,

	deleteCompanyDetailsResp: null,

	addInstanceDetailsResponse: null,
	addInstanceName: null,
	addAlterTableDetailsResponse: null,

	fetchExistDataResponse: null,

	// FINANCE API FOR COMPANY
	addCompanyResp: null,
	updateCompanyResp: null,
	deleteCompanyResp: null,
};

const companyReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/*************** Create Company Start ******************/
		case CompanyActionTypes.ADD_COMPANY_DETAILS_SUCCESS:
			return { ...state, addCompanyDetailsResp: action.payload };

		case CompanyActionTypes.ADD_COMPANY_DETAILS_FAILURE:
			return { ...state, addCompanyDetailsResp: action.payload };

		case CompanyActionTypes.ADD_COMPANY_DETAILS_RESPONSE_CHANGED:
			return { ...state, addCompanyDetailsResp: null };
		/*************** Create Company End ******************/

		/*************** Get All Company List Start ******************/
		case CompanyActionTypes.GET_COMPANY_LIST_SUCCESS:
			return {
				...state,
				getCompanyListResp: action.payload,
				getCompanyListArr: docodeHexResponse(action.payload, 'GetAllCompanyListKey'),
			};

		case CompanyActionTypes.GET_COMPANY_LIST_FAILURE:
			return { ...state, getCompanyListResp: action.payload, getCompanyListArr: [] };

		case CompanyActionTypes.GET_COMPANY_LIST_RESPONSE_CHANGED:
			return { ...state, getCompanyListResp: null };

		/*************** Get All Company List Start ******************/

		/*************** Fetch Company Details Start ******************/
		case CompanyActionTypes.FETCH_COMPANY_DETAILS_SUCCESS:
			return {
				...state,
				fetchCompanyDetailsResp: action.payload,
				fetchCompanyDetailsArr: docodeHexResponse(action.payload, 'FetchCompanyDetailsKey'),
			};

		case CompanyActionTypes.FETCH_COMPANY_DETAILS_FAILURE:
			return {
				...state,
				fetchCompanyDetailsResp: action.payload,
				fetchCompanyDetailsArr: [],
			};

		case CompanyActionTypes.FETCH_COMPANY_DETAILS_RESPONSE_CHANGED:
			return { ...state, fetchCompanyDetailsResp: null };
		/*************** Fetch Company Details End ******************/

		/*************** Update Company Details Start ******************/
		case CompanyActionTypes.UPDATE_COMPANY_DETAILS_SUCCESS:
			return {
				...state,
				updateCompanyDetailsResp: action.payload,
			};

		case CompanyActionTypes.UPDATE_COMPANY_DETAILS_FAILURE:
			return {
				...state,
				updateCompanyDetailsResp: action.payload,
			};

		case CompanyActionTypes.UPDATE_COMPANY_DETAILS_RESPONSE_CHANGED:
			return { ...state, updateCompanyDetailsResp: null };
		/*************** Update Company Details End ******************/

		/*************** Delete Company Details Start ******************/
		case CompanyActionTypes.DELETE_COMPANY_DETAILS_SUCCESS:
			return {
				...state,
				deleteCompanyDetailsResp: action.payload,
			};

		case CompanyActionTypes.DELETE_COMPANY_DETAILS_FAILURE:
			return {
				...state,
				deleteCompanyDetailsResp: action.payload,
			};

		case CompanyActionTypes.DELETE_COMPANY_DETAILS_RESPONSE_CHANGED:
			return { ...state, deleteCompanyDetailsResp: null };
		/*************** Delete Company Details End ******************/

		// COMPANY FOR FINANCE
		/*************** Create Company For Finance Start ******************/
		case CompanyActionTypes.CREATE_COMPANY_SUCCESS:
			return { ...state, addCompanyResp: action.payload };

		case CompanyActionTypes.CREATE_COMPANY_FAILURE:
			return { ...state, addCompanyResp: action.payload };

		case CompanyActionTypes.CREATE_COMPANY_RESPONSE_CHANGED:
			return { ...state, addCompanyResp: null };
		/*************** Create Company For Finance End ******************/

		/*************** Update Company For Finance Start ******************/
		case CompanyActionTypes.UPDATE_COMPANY_SUCCESS:
			return { ...state, updateCompanyResp: action.payload };

		case CompanyActionTypes.UPDATE_COMPANY_FAILURE:
			return { ...state, updateCompanyResp: action.payload };

		case CompanyActionTypes.UPDATE_COMPANY_RESPONSE_CHANGED:
			return { ...state, updateCompanyResp: null };
		/*************** Update Company For Finance End ******************/

		/*************** Delete Company For Finance Start ******************/
		case CompanyActionTypes.DELETE_COMPANY_SUCCESS:
			return { ...state, deleteCompanyResp: action.payload };

		case CompanyActionTypes.DELETE_COMPANY_FAILURE:
			return { ...state, deleteCompanyResp: action.payload };

		case CompanyActionTypes.DELETE_COMPANY_RESPONSE_CHANGED:
			return { ...state, deleteCompanyResp: null };
		/*************** Delete Company For Finance End ******************/

		/** ***************** ADD INSTANCE DETAILS START *********************** */
		case CompanyActionTypes.ADD_INSTANCE_DETAILS_SUCCESS:
			return {
				...state,
				addInstanceDetailsResponse: action.payload,
				addInstanceName: action.payload,
			};

		case CompanyActionTypes.ADD_INSTANCE_DETAILS_FAILURE:
			return { ...state, addInstanceDetailsResponse: action.payload };

		case CompanyActionTypes.ADD_INSTANCE_DETAILS_RESPONSE_CHANGED:
			return { ...state, addInstanceDetailsResponse: null };
		/** ***************** ADD INSTANCE DETAILS END *********************** */

		/** ***************** ADD ALTER TABLE DETAILS START *********************** */
		case CompanyActionTypes.ADD_ALTER_TABLE_SUCCESS:
			return {
				...state,
				addAlterTableDetailsResponse: action.payload,
				addInstanceName: action.payload,
			};

		case CompanyActionTypes.ADD_ALTER_TABLE_FAILURE:
			return { ...state, addAlterTableDetailsResponse: action.payload };

		case CompanyActionTypes.ADD_ALTER_TABLE_RESPONSE_CHANGED:
			return { ...state, addAlterTableDetailsResponse: null };
		/** ***************** ADD ALTER TABLE DETAILS END *********************** */

		/** ***************** FETCH EXIST DATA START *********************** */
		case CompanyActionTypes.FETCH_EXIST_DATA_SUCCESS:
			return {
				...state,
				fetchExistDataResponse: action.payload,
			};

		case CompanyActionTypes.FETCH_EXIST_DATA_FAILURE:
			return {
				...state,
				fetchExistDataResponse: action.payload,
			};

		case CompanyActionTypes.FETCH_EXIST_DATA_RESPONSE_CHANGED:
			return {
				...state,
				fetchExistDataResponse: null,
			};
		/** ***************** FETCH EXIST DATA END *********************** */

		default:
			return state;
	}
};

export default companyReducer;
